export default "__VITE_ASSET__BzbjUnrt__"